export const GOOGLE = 'Google';
export const FACEBOOK = 'Facebook';
export const APPLE = 'Apple';
export const SIGN_UP_FREE = 'sign up for free';
export const REGISTRATION = 'registration';
export const LOGIN = 'login';
export const LOG_IN = 'log in';
export const ADD_TEAM_MEMBER = 'add team member';
export const DELETE_CONTACT = 'Delete Contact';
export const DELETE_ITEM = 'Delete Item';
export const DELETE_CONTACT_DESCRIPTION = 'Are you sure you want to delete contact?';
export const DELETE_ITEM_DESCRIPTION = 'Are you sure you want to delete item?';
export const TEAM_MEMBER = 'Team members';
export const MEMBER = 'Member';
export const LAST_ACTIVE = 'Last active';
export const ROLE = 'Role';
export const SIGN_UP = 'sign up';
export const EDIT_TEAM_MEMBER = 'Edit team member';

